import React, { useState, useEffect } from 'react';
import { Card, Select, Spin, Tag, Typography, Row, Col, Statistic } from 'antd';
import { BankOutlined, HomeOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { mockDataService } from '../../../services/mockDataService';
import './AccountList.css';

const { Title, Text } = Typography;
const { Option } = Select;

const AccountList = () => {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeFilter, setTypeFilter] = useState('all');

  useEffect(() => {
    mockDataService.getAccounts().then((data) => {
      setAccounts(data);
      setLoading(false);
    });
  }, []);

  const filtered = accounts.filter(
    (a) => typeFilter === 'all' || a.type === typeFilter
  );

  const isSavings = (type) => type === 'Savings';

  if (loading) {
    return (
      <div className="account-list-loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="account-list-container">
      <div className="account-list-header">
        <div>
          <Title level={3} style={{ margin: 0, color: '#1C2B4A' }}>My Accounts</Title>
          <Text type="secondary" style={{ fontSize: 13 }}>
            {accounts.length} account{accounts.length !== 1 ? 's' : ''} linked to your profile
          </Text>
        </div>
        <Select
          value={typeFilter}
          onChange={setTypeFilter}
          style={{ width: 160 }}
          size="middle"
        >
          <Option value="all">All Accounts</Option>
          <Option value="Savings">Savings</Option>
          <Option value="Mortgage">Mortgage</Option>
        </Select>
      </div>

      <Row gutter={[20, 20]}>
        {filtered.map((account) => (
          <Col xs={24} sm={12} lg={8} key={account.accountNumber}>
            <Card
              className={`account-card ${isSavings(account.type) ? 'savings-card' : 'mortgage-card'}`}
              hoverable
              onClick={() => navigate(`/accounts/${account.accountNumber}`)}
              bodyStyle={{ padding: 0 }}
            >
              <div className={`card-header ${isSavings(account.type) ? 'card-header-savings' : 'card-header-mortgage'}`}>
                <div className="card-header-top">
                  <div className="card-icon-wrap">
                    {isSavings(account.type)
                      ? <BankOutlined style={{ fontSize: 20, color: '#fff' }} />
                      : <HomeOutlined style={{ fontSize: 20, color: '#fff' }} />}
                  </div>
                  <Tag
                    color={isSavings(account.type) ? 'blue' : 'geekblue'}
                    style={{ border: 'none', fontWeight: 600, fontSize: 11 }}
                  >
                    {account.type.toUpperCase()}
                  </Tag>
                </div>
                <div className="card-acct-number">
                  ••••{account.accountNumber.slice(-4)}
                </div>
              </div>

              <div className="card-body">
                <Statistic
                  title={<span style={{ fontSize: 12, color: '#64748B', fontWeight: 500 }}>
                    {isSavings(account.type) ? 'Available Balance' : 'Outstanding Balance'}
                  </span>}
                  value={account.balance}
                  precision={2}
                  prefix="$"
                  valueStyle={{ fontSize: 24, fontWeight: 700, color: '#1C2B4A' }}
                />
                <div className="card-footer-row">
                  <Tag color={account.status === 'Active' ? 'success' : 'error'}>
                    {account.status}
                  </Tag>
                  <span className="card-view-link">
                    View Details <ArrowRightOutlined />
                  </span>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AccountList;
